import AppleCalendarIcon from "@/components/icons/apps/AppleCalendarIcon.vue";
import MicrosoftOutlookIcon from "@/components/icons/apps/MicrosoftOutlookIcon.vue";

import type { IntegrationItem } from "./types";

const unavailableItems: IntegrationItem[] = [
  {
    id: "microsoft-outlook",
    name: "Microsoft Outlook",
    description: "Sync emails and calendar from Outlook.",
    type: "microsoft-outlook",
    iconComponent: MicrosoftOutlookIcon,
    onClick: () => {},
    unavailable: true,
    helpUrl:
      "https://help.routine.co/articles/1370505-microsoft-outlook-calendar",
  },
  {
    id: "apple-calendar",
    name: "Apple Calendar",
    description: "Sync events from Apple Calendar.",
    type: "apple-calendar",
    iconComponent: AppleCalendarIcon,
    onClick: () => {},
    unavailable: true,
  },
];

export function useUnavailableIntegrations() {
  return { items: unavailableItems };
}
